import React, { useRef, useState } from 'react';

import { localize } from 'common/utils';
import { useSharedMenuLink } from 'modules/menu/hooks/useSharedMenuLink';
import { MenuEditorRoot } from 'modules/shared-menu/components/MenuEditorRoot';
import { SharedMenu } from 'modules/shared-menu/types';
import { useVenueContext } from 'modules/venue/VenueContext';

import { RestrictedVenueLevelHeader } from './components/RestrictedVenueLevelHeader';
import { SingleVenueHeader } from './components/SingleVenueHeader';
import { Root } from '../../components/CommonStyles';
import AddCategoryModal from '../SharedMenuEditorPage/components/AddCategoryModal';
import MenuEditorDnDContext from '../SharedMenuEditorPage/components/dnd/MenuEditorDnDContext';
import { MenuMainElementRefContext } from '../SharedMenuEditorPage/context/MenuMainElementRefContext';
import { WoltSpecialsContextProvider } from '../SharedMenuEditorPage/context/WoltSpecialsContext';

type VenueLevelMenuEditorPageProps = {
  selection: SharedMenu;
};

export const VenueLevelMenuEditorPage = ({ selection }: VenueLevelMenuEditorPageProps) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const mainElementRef = useRef<HTMLDivElement>(null);
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
  const [isImageGalleryOpen, setIsImageGalleryOpen] = useState(false);
  const venue = useVenueContext();
  const { sharedMenuLink } = useSharedMenuLink();
  const isSharedVenue = !!sharedMenuLink?.selection_is_shared;

  const onClickAddCategory = () => setIsAddCategoryModalOpen(true);
  const onClickImageGallery = () => setIsImageGalleryOpen(true);

  return (
    <WoltSpecialsContextProvider>
      <MenuMainElementRefContext.Provider value={mainElementRef}>
        <Root ref={rootRef}>
          <MenuEditorDnDContext>
            {isSharedVenue ? (
              <RestrictedVenueLevelHeader selectionName={localize(selection.name, selection.primary_language)} />
            ) : (
              <SingleVenueHeader
                selection={selection}
                onClickCreateCategory={onClickAddCategory}
                onClickImageGallery={onClickImageGallery}
              />
            )}
            <MenuEditorRoot
              onClickAddCategory={onClickAddCategory}
              woltcomUrl={venue.public_url}
              isImageGalleryOpen={isImageGalleryOpen}
              onCloseImageGallery={() => setIsImageGalleryOpen(false)}
            />
          </MenuEditorDnDContext>
        </Root>

        <AddCategoryModal isOpen={isAddCategoryModalOpen} onClose={() => setIsAddCategoryModalOpen(false)} />
      </MenuMainElementRefContext.Provider>
    </WoltSpecialsContextProvider>
  );
};
